import type { PaymentType } from 'src/app/shared/utils/payments';

import type { PromotePageState } from './types';

export const mutations = {
	setAmount: (state: PromotePageState, amount: number): PromotePageState => ({
		...state,
		amount,
	}),

	setEmail: (state: PromotePageState, email: string): PromotePageState => ({
		...state,
		email,
	}),
	setGeneralErrorMessage: (state: PromotePageState, generalErrorMessage: string): PromotePageState => ({
		...state,
		...{ formState: { status: 'error', error: generalErrorMessage } },
	}),
	clearGeneralErrorMessage: (state: PromotePageState): PromotePageState => ({
		...state,
		...{ formState: { status: 'ready' } },
	}),
	setLoading: (state: PromotePageState): PromotePageState => ({
		...state,
		...{ formState: { status: 'loading' } },
	}),
	clearLoading: (state: PromotePageState): PromotePageState => ({
		...state,
		...{ formState: { status: 'ready' } },
	}),
	setFirstName: (state: PromotePageState, firstName: string): PromotePageState => ({
		...state,
		firstName,
		name: `${firstName} ${state.lastName}`,
	}),
	setHasNewCreditCardData: (state: PromotePageState, hasNewCreditCardData: boolean): PromotePageState => ({
		...state,
		hasNewCreditCardData,
	}),
	setLastName: (state: PromotePageState, lastName: string): PromotePageState => ({
		...state,
		lastName,
		name: `${state.firstName} ${lastName}`,
	}),
	setName: (state: PromotePageState, name: string): PromotePageState => ({
		...state,
		name,
	}),
	setPublic: (state: PromotePageState, isPublic: boolean): PromotePageState => ({
		...state,
		isPublic,
	}),
	setShouldSavePaymentMethod: (state: PromotePageState, shouldSavePaymentMethod: boolean): PromotePageState => ({
		...state,
		paymentMethodSaveOptions: {
			...state.paymentMethodSaveOptions,
			shouldSavePaymentMethod,
		},
	}),
	setUsingSavedPaymentMethod: (state: PromotePageState, usingSavedPaymentMethod: boolean): PromotePageState => ({
		...state,
		usingSavedPaymentMethod,
	}),
	setValidationErrors: (
		state: PromotePageState,
		validationErrors: PromotePageState['validationErrors'],
	): PromotePageState => ({
		...state,
		validationErrors,
	}),
	setCustomAmountSelected: (state: PromotePageState, customAmountSelected: boolean): PromotePageState => ({
		...state,
		customAmountSelected,
	}),
	setPaymentType: (state: PromotePageState, paymentType: PaymentType): PromotePageState => ({
		...state,
		paymentType,
	}),
	setSavedPaymentExperimentVariant: (
		state: PromotePageState,
		savedPaymentExperimentVariant: string,
	): PromotePageState => ({
		...state,
		savedPaymentExperimentVariant,
	}),
};
